"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanonizedHoseCodes = void 0;
const getHoseCodesForAtomsInternal_js_1 = require("../hose/getHoseCodesForAtomsInternal.js");
const tagAtom_1 = require("../util/tagAtom");
function getCanonizedHoseCodes(topicMolecule) {
    const options = topicMolecule.options;
    const heterotopicSymmetryRanks = topicMolecule.heterotopicSymmetryRanks;
    const moleculeWithH = topicMolecule.moleculeWithH;
    const finalRanks = topicMolecule.finalRanks;
    const canonizedHoseCodes = new Array(moleculeWithH.getAllAtoms());
    moleculeWithH.ensureHelperArrays(topicMolecule.molecule.getOCL().Molecule
        .cHelperSymmetryStereoHeterotopicity);
    const cache = {};
    for (let i = 0; i < topicMolecule.moleculeWithH.getAllAtoms(); i++) {
        const rank = heterotopicSymmetryRanks[i];
        if (rank && cache[rank]) {
            canonizedHoseCodes[finalRanks[i]] = cache[rank].diaID;
            continue;
        }
        const tempMolecule = topicMolecule.moleculeWithH.getCompactCopy();
        (0, tagAtom_1.tagAtom)(tempMolecule, i);
        const hoses = (0, getHoseCodesForAtomsInternal_js_1.getHoseCodesForAtomsInternal)(tempMolecule, options);
        canonizedHoseCodes[finalRanks[i]] = hoses;
    }
    return canonizedHoseCodes;
}
exports.getCanonizedHoseCodes = getCanonizedHoseCodes;
//# sourceMappingURL=getCanonizedHoseCodes.js.map